var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Views.Options.Dashboard.Main_Title')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }